import { NgModule } from '@angular/core';
import { WorkItemChatListComponent } from './work-item-chat-list.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { WorkitemActivityIndicatorModule } from 'shared/components/workitem-activity-indicator/workitem-activity-indicator.module';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { TooltipActionListModule } from 'shared/components/tooltip-action-list/tooltip-action-list.module';
import { WorkitemAnswerNextModule } from '../shared/workitem-answer-next/workitem-answer-next.module';
import { CountdownTimerModule } from 'shared/components/countdown-timer/countdown-timer.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { SkeletonLoaderModule } from 'shared/components/skeleton-loader/skeleton-loader.module';
import { WorkItemInteractionModule } from '../shared/workitem-interaction/work-item-interaction.module';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule,
    CountdownTimerModule,
    TooltipActionListModule,
    WorkitemActivityIndicatorModule,
    WorkitemAnswerNextModule,
    CustomPipesModule,
    SkeletonLoaderModule,
    WorkItemInteractionModule
  ],
  declarations: [
    WorkItemChatListComponent
  ],
  exports: [
    WorkItemChatListComponent
  ]
})
export class WorkItemChatListModule {}
